export const state = {
    estoque: {},
    estoques: [],
    modalCadastroEstoque: false,
    modalExcluirEstoque:false,
    modalImprimirEstoque: false,
    modalMovimentacaoEstoque: false,
    listarEstoque: false,
}

export default {}